import {fromJS} from 'immutable'
import { get } from '../../util/http'
import debounce from 'lodash/debounce'
import { CLEAR_SEARCH, PROCESS_TRENDING_TOPICS } from './search'

const NUM_SUGGESTIONS = 3

/**
 * Actions
 */
const ATTEMPT_GET_SUGGESTION_RESULTS = 'expii/searchSuggestions/ATTEMPT_GET_SUGGESTION_RESULTS'
const PROCESS_SUGGESTION_RESULTS = 'expii/searchSuggestions/PROCESS_SUGGESTION_RESULTS'
const MOVE_CURSOR = 'expii/searchSuggestions/MOVE_CURSOR'

/**
 * Reducer
 */
const defaultState = fromJS({
  isFetching: false,
  query: '',
  esResults: {},
  trendingTopics: [],
  cursor: -1
})

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
  case ATTEMPT_GET_SUGGESTION_RESULTS:
    return state.merge(
      fromJS({
        query: action.query,
        cursor: -1,
        isFetching: true
      })
    )
  case PROCESS_SUGGESTION_RESULTS:
    const results = Array.from(
      new Set(action.payload.results.results.map(r => ({
        title: r._source.title,
        renderedTitle: r._source.rendered_title
      }))
      ))
    return state.merge(
      fromJS({
        esResults: results.slice(0,NUM_SUGGESTIONS),
        isFetching: false
      })
    )
  case PROCESS_TRENDING_TOPICS: {
    const results = Array.from(
      new Set(action.payload.trending.map(r => ({
        title: r.title,
        renderedTitle: r.renderedTitle,
        slug: r.slug
      }))
      ))
    return state.merge(
      fromJS({
        trendingTopics: results.slice(0,NUM_SUGGESTIONS)
      })
    )
  }
  case MOVE_CURSOR:
    const {offset} = action
    const cursor = state.get('cursor')
    const length = state.get('esResults').size ? state.get('esResults').size : state.get('trendingTopics').size
    if ( cursor+offset < length && cursor+offset >= -1) {
      return state.update('cursor', value => value + offset)
    } else {
      return state
    }
  case CLEAR_SEARCH:
    return defaultState.set(
      'trendingTopics',
      state.get('trendingTopics')
    )
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function attemptGetSuggestionResults(query) {
  return { type: ATTEMPT_GET_SUGGESTION_RESULTS, query }
}
export function processSuggestionResults(results_data) {
  return { type: PROCESS_SUGGESTION_RESULTS, payload: results_data }
}
export function moveCursor(offset) {
  return { type: MOVE_CURSOR, offset}
}

/**
 * Side Effects
 */

const debouncedSearch = debounce((query, callback) => {
  //mixpanel.track('XP_main_search_bar_query', { query: query });
  return get(
    `/api/v2/t/suggestions?q=${query}`
  ).then(json => {
    callback(json)
  })
}, 250)

export function getSearchSuggestionResults(query) {
  return (dispatch, getState) => {
    dispatch(attemptGetSuggestionResults(query))
    return debouncedSearch(query, json => {
      let { success, output } = json
      json = {
        success: success,
        query: query,
        results: output
      }
      dispatch(processSuggestionResults(json))
    })
  }
}
/**
 * Selectors
 */
export const selectSuggestions = state => {
  const domain = state.get('searchSuggestions')
  const esResults = domain.get('esResults')
  const trending = domain.get('trendingTopics')
  const suggestions = esResults.isEmpty() ? trending : esResults
  return {
    suggestions: suggestions,
    query: domain.get('query'),
    isFetching: domain.get('isFetching'),
    didGetResults: !esResults.isEmpty(),
    cursor: domain.get('cursor')
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/searchSuggestions.js